import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';

import { Page404Component } from './extrapages/page404/page404.component';
import { AccountRoutingModule } from './account/account-routing.module';



const routes: Routes = [
  // { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  // tslint:disable-next-line: max-line-length

   // ==============================
  // SELECCIÓN DE UBICACIÓN
  // ==============================

  {
    path: 'locations',
    loadChildren: () =>
      import('./pages/locations/locations.module')
        .then(m => m.LocationsModule)
  },

{
    path: 'corporate',
    loadChildren: () =>
      import('./corporate/corporate.module')
        .then(m => m.CorporateModule),

    // canActivate: [CorporateGuard],

    // canLoad: [CorporateGuard]
  },
{
    path: 'movil',
    loadChildren: () =>
        import('./movil/movil.module')
        .then(m => m.MovilModule),

    // canActivate: [CorporateGuard],

    // canLoad: [CorporateGuard]
  },

  // ==============================
  // REDIRECCIÓN INICIAL
  // ==============================

  {
    path: '',
    redirectTo: '/locations',
    pathMatch: 'full'
  },


  // { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard],canLoad:[AuthGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard], canLoad:[AuthGuard] },
  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top', relativeLinkResolution: 'legacy' }),AccountRoutingModule],
  exports: [RouterModule]
})

export class AppRoutingModule { }
